// Synchronous; runs once before React mounts to prevent dark-flash.
// Mirrors Spor's pattern: stored preference may be "system" | "light" | "dark".

const STORAGE_KEY = "vroom-theme";

type StoredTheme = "system" | "light" | "dark";

function readStored(): StoredTheme {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === "light" || value === "dark" || value === "system") return value;
  } catch {
    // Ignore — localStorage may be unavailable (private mode, SSR).
  }
  return "system";
}

function resolve(stored: StoredTheme): "light" | "dark" {
  if (stored !== "system") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

const resolved = resolve(readStored());
document.documentElement.classList.remove("light", "dark");
document.documentElement.classList.add(resolved);
